// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__LEFZd","inline":"Card_inline__ZG4vM","bed":"Card_bed__rHiJI","lenkeBaseOverride":"Card_lenkeBaseOverride__zc2Yd"};